import React from 'react';
import Dialog from './dialog';

interface Props {
  show: boolean;
  title?: string;
  negative?: string;
  positive?: string;
  children: React.ReactNode;
  onNegativeClick: () => void;
  onPositiveClick: () => void;
}

const Confirm: React.FC<Props> = ({ ...props }: Props) => (
  <Dialog
    showTop
    title={props.title ?? 'Confirmation'}
    negative={props.negative ?? 'Cancel'}
    positive={props.positive ?? 'Confirm'}
    {...props}
  >
    <div style={{ padding: '10px 0' }}>{props.children}</div>
  </Dialog>
);

export default Confirm;
